import { useMemo } from 'react';

import find from 'lodash/find';

import {
  LaborLevelResponse,
  useAllLaborLevelsWithOptionsGet,
} from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const useAllLabourLevelLevelOptionsGet = ({
  level,
  getLaborLevelLevelLabel,
}: {
  level: number;
  getLaborLevelLevelLabel?: (child: LaborLevelResponse) => string;
}) => {
  const {
    options: baseOptions,
    isLoading,
    isSuccess,
  } = useAllLaborLevelsWithOptionsGet({
    getLaborLevelLevelLabel,
  });
  const options = useMemo(() => {
    return (
      find(baseOptions, (item) => item.meta.level === level)?.children ?? []
    );
  }, [baseOptions, level]);
  return { options, isLoading, isSuccess };
};

type ExtraParameters = Parameters<typeof useAllLabourLevelLevelOptionsGet>[0];

type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => props;

export const { AllLaborLevelLevelsIdToLabelRenderer } =
  createOptionsFieldBuilder({
    prefix: 'AllLaborLevelLevels',
    useOptionsHook: useAllLabourLevelLevelOptionsGet,
    extractHookParams: hookParamsGetter,
  });
